import axios from "axios"; //axios@0.18
import * as log from "./LogService";
import * as Const from "../_Const";
import { useNavigate } from "react-router";
import axiosRetry from "axios-retry";

export default function useAxios(url) {
  //const { x, setX } = useState();
  const navigate = useNavigate();
  //console.log("axios" + url);
  let instance = axios.create({
    baseURL: url, //Const.API_URL,
  });

  //nastaveni exponential backoff
  //stava ze nefunguje jak ma a pri testu kdy vypnut spojeni, tak po obnoveni spojeni
  // napriklad po minute jakoby dobihaly nakumulovane requesty, foti samo prazdne sanky vcetne beep a led, tak ze to samozrejme haze chybu jak do api tak do aplikace
  // axiosRetry(instance, {
  //   retries: 3,
  //   retryDelay: axiosRetry.exponentialDelay,
  //   // retryDelay: (retryCount) => {
  //   //   return retryCount * 2000;
  //   // },
  //   onRetry: (retryCount, error, requestConfig) => {
  //     const now = new Date().toLocaleTimeString("cs-CZ", {
  //       timeZone: "Europe/Prague",
  //       hour12: false,
  //       hour: "2-digit",
  //       minute: "2-digit",
  //       second: "2-digit",
  //       fractionalSecondDigits: 3,
  //     });

  //     console.warn(`[${now}] Opakuji požadavek (pokus č. ${retryCount}). ` + `Důvod: ${error.message}` + `Url: ${requestConfig.url}`);

  //     // Můžete si do konfigurace přidat vlastní příznak
  //     requestConfig.wasRetried = true;
  //   },
  // });

  //axios.defaults.baseURL =

  // Add a request interceptor
  instance.interceptors.request.use(
    /*function (config) {
      // RS.setLoading();
      return config;
    },
    function (error) {
      ///RS.setLoading(false);
      // Do something with request error
      return Promise.reject(error);
    }*/

    async (config) => {
      // handle config eg-: setting token
      return config;
    },
    (error) => Promise.reject(error),
  );

  instance.interceptors.response.use(
    //undefined,
    (response) => {
      return response;
    },
    (error) => {
      // Inicializace čítače
      // const config = error.config;
      // config.__retryCount = config.__retryCount || 0;

      const expectedError = error.response && error.response.status >= 400 && error.response.status < 500;

      if (!expectedError) {
        // RS.toastError("Nastala chyba při komunikaci se serverem");
        log.e("Nastala chyba při komunikaci se serverem e:", error);
      }
      if (Const.isTerminal()) {
        //handluju vse sam
      } else {
        if (error.response && error.response.status === 400) {
          //handluju sam ve FormContext
          //navigate(Const.PAGE_ERROR_NOT_ENABLED);
        } else if (error.response && error.response.status === 406) {
          //handluju sam ve FormContext
        } else if (error.response && error.response.status === 409) {
          //handluju sam ve FormContext
        } else {
          log.e("Presmerovani na PAGE_ERROR");
          navigate(Const.PAGE_ERROR);
        }
      }
      //return axios(config);
      return Promise.reject(error);
    },
  ); //null znamena intercept success, v tomto pripade nepotrbuji, mozna pro logovani v realne aplikaci

  // function setJwt(token) {
  //   //axios.defaults.headers.common["x-auth-token"] = jwt;
  //   axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  // }

  // function setUnAuthorizeCallback(callback) {
  //   unAuthorizeCallback = callback;
  // }
  return { instance };
}

//export default useAxios;

// {
//   get: axios.get,
//   put: axios.put,
//   delete: axios.delete,
//   post: axios.post,
//   // setUnAuthorizeCallback,
// };*
